<template>
    <div class="voucher-item"
         :class="{ 'voucher-item--disabled': !item.item }"
         @click.prevent="onClick">
        <div>
            {{ item.name }}
            <span v-if="item.item">
                {{ currencyFilter(item.item.getPrice()) }}
            </span>
            <small v-else-if="branchNames.length > 0">
                {{ l('AVAILABLE_AT') }}
                {{ branchNames.join(', ') }}
            </small>
            <small v-else>
                {{ l('NOT_IN_BRANCH') }}
            </small>
        </div>
        <RoundBtn v-if="item.item"
                  color="primary"
                  :filled="true"
                  icon="fa-solid fa-shopping-cart"
                  @click="onClick"></RoundBtn>
    </div>
</template>

<script>
import RoundBtn from '@/vue/components/RoundBtn';
import { container } from '@/container';

export default {
    name: 'VoucherItem',

    components: {
        RoundBtn,
    },

    props: {
        item: {
            type: Object, // PlaceholderItem
            required: true,
        },
    },

    emits: [
        'click',
    ],

    data() {
        return {
            branchNames: [],
        };
    },

    created() {
        this.branchNames = this.item.branchIDs
            .map((branchIDs) => {
                const branch = container.userService.getBranchByID(branchIDs);
                return branch ? branch.name : null;
            })
            .filter((branchName) => !!branchName);
    },

    methods: {
        onClick() {
            if (this.item.item) {
                this.$emit('click', this.item.item);
            }
        },
    },
};
</script>

<style lang="less">
@import "../../../../less/variables";

.voucher-item {
    display: flex;
    grid-gap: 10px;
    padding: 5px;
    cursor: pointer;
    background: white;
    font-size: @font-size-medium;
    font-weight: normal;
    border: 1px solid @btn-default-border;
    color: @dt-dark-blue;
    box-shadow: 0 3px 8px -9px black;
    border-radius: @border-radius-base;
    text-decoration: none;
    text-align: center;
    overflow: hidden;
    justify-content: center;
    align-items: center;

    &--disabled {
        cursor: default;
        opacity: .65;
        color: @btn-disabled-color !important;
        background: @btn-disabled-bg !important;
        border-color: @btn-disabled-border !important;
    }

    > div {
        flex-grow: 1;
        flex-shrink: 1;

        > span,
        > small {
            display: block;
            margin-top: 2px;
            color: @text-muted;
        }
    }
}
</style>
